import * as actionTypes from './actionTypes';
import { DateSelectedType } from '@app/src/common/datePicker/types/Date';
import { getStateConfig } from '@app/src/common/datePicker/state/calendar/constants';
import { getCalendar } from './utils';

interface State {
  dateSelectedComercioD: DateSelectedType[];
  dateSelectedComercioMS: DateSelectedType[];
  dateSelectedTalanD: DateSelectedType[];
  dateSelectedTalanS: DateSelectedType[];
  dateSelectedTalanLV: DateSelectedType[];
  dateSelectedDeporSD: DateSelectedType[];
  dateSelectedDeporLV: DateSelectedType[];
  calendarMonths: any;
}

const initialState: State = {
  dateSelectedComercioD: [],
  dateSelectedComercioMS: [],
  dateSelectedTalanD: [],
  dateSelectedTalanS: [],
  dateSelectedTalanLV: [],
  dateSelectedDeporSD: [],
  dateSelectedDeporLV: [],
  calendarMonths: {}
};

const addDateSelectedComercioD = (action, state) => {
  return {
    ...state,
    dateSelectedComercioD: [
      ...state.dateSelectedComercioD,
      action.date
    ]
  };
};

const addDateSelectedComercioMS = (action, state) => {
  return {
    ...state,
    dateSelectedComercioMS: [
      ...state.dateSelectedComercioMS,
      action.date
    ]
  };
};

const addDateSelectedTalanD = (action, state) => {
  return {
    ...state,
    dateSelectedTalanD: [
      ...state.dateSelectedTalanD,
      action.date
    ]
  };
};

const addDateSelectedTalanS = (action, state) => {
  return {
    ...state,
    dateSelectedTalanS: [
      ...state.dateSelectedTalanS,
      action.date
    ]
  };
};

const addDateSelectedTalanLV = (action, state) => {
  return {
    ...state,
    dateSelectedTalanLV: [
      ...state.dateSelectedTalanLV,
      action.date
    ]
  };
};

const addDateSelectedDeporSD = (action, state) => {
  return {
    ...state,
    dateSelectedDeporSD: [
      ...state.dateSelectedDeporSD,
      action.date
    ]
  };
};

const addDateSelectedDeporLV = (action, state) => {
  return {
    ...state,
    dateSelectedDeporLV: [
      ...state.dateSelectedDeporLV,
      action.date
    ]
  };
};

const addDateSelectedAllComercioD = (action, state) => {
  return {
    ...state,
    dateSelectedComercioD: action.dates
  };
};

const addDateSelectedAllComercioMS = (action, state) => {
  return {
    ...state,
    dateSelectedComercioMS: action.dates
  };
};

const addDateSelectedAllTalanD = (action, state) => {
  return {
    ...state,
    dateSelectedTalanD: action.dates
  };
};

const addDateSelectedAllTalanS = (action, state) => {
  return {
    ...state,
    dateSelectedTalanS: action.dates
  };
};

const addDateSelectedAllTalanLV = (action, state) => {
  return {
    ...state,
    dateSelectedTalanLV: action.dates
  };
};

const addDateSelectedAllDeporSD = (action, state) => {
  return {
    ...state,
    dateSelectedDeporSD: action.dates
  };
};

const addDateSelectedAllDeporLV = (action, state) => {
  return {
    ...state,
    dateSelectedDeporLV: action.dates
  };
};

const deleteDateSelectedComercioD = (date, state) => {
  if (date === []) {
    return {
      ...state,
      dateSelectedComercioD: []
    };
  }
  return {
    ...state,
    dateSelectedComercioD: [...date]
  };
};

const deleteDateSelectedComercioMS = (date, state) => {
  if (date === []) {
    return {
      ...state,
      dateSelectedComercioMS: []
    };
  }
  return {
    ...state,
    dateSelectedComercioMS: [...date]
  };
};

const deleteDateSelectedTalanD = (date, state) => {
  if (date === []) {
    return {
      ...state,
      dateSelectedTalanD: []
    };
  }
  return {
    ...state,
    dateSelectedTalanD: [...date]
  };
};

const deleteDateSelectedTalanS = (date, state) => {
  if (date === []) {
    return {
      ...state,
      dateSelectedTalanS: []
    };
  }
  return {
    ...state,
    dateSelectedTalanS: [...date]
  };
};

const deleteDateSelectedTalanLV = (date, state) => {
  if (date === []) {
    return {
      ...state,
      dateSelectedTalanLV: []
    };
  }
  return {
    ...state,
    dateSelectedTalanLV: [...date]
  };
};

const deleteDateSelectedDeporSD = (date, state) => {
  if (date === []) {
    return {
      ...state,
      dateSelectedDeporSD: []
    };
  }
  return {
    ...state,
    dateSelectedDeporSD: [...date]
  };
};

const deleteDateSelectedDeporLV = (date, state) => {
  if (date === []) {
    return {
      ...state,
      dateSelectedDeporLV: []
    };
  }
  return {
    ...state,
    dateSelectedDeporLV: [...date]
  };
};

const dateAddConfig = {
  1: addDateSelectedComercioD,
  2: addDateSelectedTalanD,
  3: addDateSelectedComercioMS,
  4: addDateSelectedTalanS,
  5: addDateSelectedTalanLV,
  6: addDateSelectedDeporSD,
  7: addDateSelectedDeporLV
};

const dataAddAllConfig = {
  1: addDateSelectedAllComercioD,
  2: addDateSelectedAllTalanD,
  3: addDateSelectedAllComercioMS,
  4: addDateSelectedAllTalanS,
  5: addDateSelectedAllTalanLV,
  6: addDateSelectedAllDeporSD,
  7: addDateSelectedAllDeporLV
}

const dateDeleteConfig = {
  1: deleteDateSelectedComercioD,
  2: deleteDateSelectedTalanD,
  3: deleteDateSelectedComercioMS,
  4: deleteDateSelectedTalanS,
  5: deleteDateSelectedTalanLV,
  6: deleteDateSelectedDeporSD,
  7: deleteDateSelectedDeporLV
};

export const calendar = (state: State = initialState, action): State => {
  switch (action.type) {
    case actionTypes.ADD_DATE_SELECTED:
      return dateAddConfig[action.idPrint](action, state);
    case actionTypes.ADD_ALL_DATE_SELECTED:
      return dataAddAllConfig[action.idPrint](action, state);
    case actionTypes.DELETE_DATE_SELECTED:
      let newDatesSelected = state[getStateConfig[action.idPrint]];
      newDatesSelected.map((day, index) => {
        if (day.dayMonth === action.date.dayMonth && day.month === action.date.month) {
          newDatesSelected.splice(index, 1);
        }
      });
      return dateDeleteConfig[action.idPrint](newDatesSelected, state);
    case actionTypes.DELETE_ALL_DATE_SELECTED:
      return dateDeleteConfig[action.idPrint]([], state);
    case actionTypes.SET_CALENDAR_DATE:
      return {
        ...state,
        calendarMonths: getCalendar(action.printData)
      };
    case actionTypes.CLEAN_ALL_DATE_SELECTED:
      return { ...initialState }
    default:
      return state;
  }
};
